import { GetScoringStandardDetailReq } from '@standard/models/get-scoring-standard-detail.model';
import { ScoringStandardDetail } from '@standard/models/scoring-standard.model';
import standardRepository from '@standard/standard.module';
import { useQuery } from '@tanstack/react-query';

// #region Constants
export const SCORING_STANDARD_DETAIL_QUERY_KEY = 'scoring-standard-detail';
// #endregion

export default function useScoringStandardDetailQuery({
  partId,
  subjectType,
}: Partial<GetScoringStandardDetailReq> = {}) {
  // #region Query
  const { data, isLoading } = useQuery<ScoringStandardDetail | undefined>({
    enabled: partId != null && subjectType != null,
    queryFn: async ({ signal }) => {
      if (partId == null || subjectType == null) return undefined;

      const response = await standardRepository.getScoringStandardDetail(
        { partId, subjectType },
        signal,
      );

      return response.body as ScoringStandardDetail | undefined;
    },
    queryKey: [SCORING_STANDARD_DETAIL_QUERY_KEY, partId, subjectType],
  });
  // #endregion

  return { data, isLoading };
}
